export const iconFontAwesomeNatureCloudSun = (
	<i className="fa-solid fa-cloud-sun"></i>
);
